export const EXCMUSERDATASTATUS_CREATE_RESET = 'EXCMUSERDATASTATUS_CREATE_RESET'
export const EXCMUSERDATASTATUS_CREATE_SET_CREATED = 'EXCMUSERDATASTATUS_CREATE_SET_CREATED'
export const EXCMUSERDATASTATUS_CREATE_SET_ERROR = 'EXCMUSERDATASTATUS_CREATE_SET_ERROR'
export const EXCMUSERDATASTATUS_CREATE_SET_VIOLATIONS = 'EXCMUSERDATASTATUS_CREATE_SET_VIOLATIONS'
export const EXCMUSERDATASTATUS_CREATE_TOGGLE_LOADING = 'EXCMUSERDATASTATUS_CREATE_TOGGLE_LOADING'
